// extracted by mini-css-extract-plugin
module.exports = {"rating":"Wf-z","numberOfStars":"Xf-z","count":"Yf-z"};